import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */



export const getFollowers = (supplierId) => ({
  type: actions.GET_SUPPLIER_FOLLOWRS,
  payload: supplierId
})

export const getFollowersCountAction = (supplierId) => ({
  type:actions.GET_SUPPLIER_FOLLOWRS_COUNT,
  payload: supplierId
})


/**
 * Actions that are fired by redux-saga watchers
 */


export const getFollowersSuccess = (payload) =>({
  type: actions.GET_SUPPLIER_FOLLOWRS_SUCCESS,
  payload
})

export const getFollowersCountSucessAction = (payload) => ({
  type: actions.GET_SUPPLIER_FOLLOWRS_COUNT_SUCCESS,
  payload
})

// Plural


/**
 * Misc
 */
export const setSuppliersIsLoadingAction = (isLoading) => ({
  type: actions.SET_SUPPLIERS_FOLLOWER_LIST_IS_LOADING,
  payload: isLoading,
});

export const setSuppliersCountAction = (count) => ({
  type: actions.SET_SUPPLIERS_FOLLOWER_LIST_COUNT,
  payload: count,
});

// export const setSearchValueAction = (value) => ({
//   type: actions.SET_SUPPLIERS_SEARCH_VALUE,
//   payload: value,
// });
